import { cache } from "swr"

export async function clearSWRCache(key)
{
  await cache.delete(key);
}